// @flow
// import RadioSelect from 'fg-frontend/src/components/RadioSelect';
// import Form from 'fg-frontend/src/components/Form';
// import SocialShare from 'fg-frontend/components/SocialShare';
// import GtmHandler from './components/GtmHandler';
// import TriggerInViewport from './components/TriggerInViewport';

// COMMON: Komponenta pro AJAX nacteni SVG spritu
import AddSvgIconSprite from './components/AddSvgIconSprite';
import LazyImage from './components/LazyImage';
import Tabs from './components/Tabs';
import BudgetKnob from './components/BudgetKnob';
import BudgetRange from './components/BudgetRange';
import SelectTabs from './components/SelectTabs';
import ProductCategorySliderSticky from './components/ProductCategorySliderSticky';
import Awards from './components/Awards';
import GoBack from './components/GoBack';
import HpAwards from './components/HpAwards';
// import PromoSlider from "./components/PromoSlider";
// COMMON: Komponenta pro sestavení subnavigace
import SecondaryNavigation from './components/SecondaryNavigation';

export default (props) => {
  switch (props.decorator || props.is) {
    // case 'RadioSelect':
    // case 'CheckboxSelect':
    //   return RadioSelect;
    // case 'SocialShare':
    //   return SocialShare;
    // case 'GtmHandler':
    //   return GtmHandler;
    // case 'TriggerInViewport':
    //   return TriggerInViewport;
    // case 'Form':
    //   return Form;
    case 'UniversalPaginationButton':
      return import('./components/UniversalPaginationButton');
    case 'AddSvgIconSprite':
      return AddSvgIconSprite;
    case 'LazyImage':
      return LazyImage;
    case 'Tabs':
      return Tabs;
    case 'BudgetKnob':
      return BudgetKnob;
    case 'BudgetRange':
      return BudgetRange;
    case 'SelectTabs':
      return SelectTabs;
    case 'ProductCategorySliderSticky':
      return ProductCategorySliderSticky;
    case 'Awards':
      return Awards;
    case 'GoBack':
      return GoBack;
    case "HpAwards":
      return HpAwards;
    case 'GoogleRecaptcha':
      return import('fg-frontend/src/components/GoogleRecaptcha');
    case 'SecondaryNavigation':
      return SecondaryNavigation;
    // case 'PromoSlider':
    //   return PromoSlider;

    default:
      console.log(`Unknown component ${props.decorator || props.is}`);
      return null;
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWebComponents.js